
import { Product } from "@/models/base";
import { ProductGroup } from "@/models/base/product-group";
import { ProductGroupService } from "@/services/product-group-service";
import { DossierConfigService } from "@/services";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			groups: [] as ProductGroup[],
		};
	},
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		}
	},
	computed: {
		useSimpleGroups():boolean {
			return DossierConfigService.getGeneralConfig().UseSimpleGroups;
		},
		simplePath():string {
			return [this.product.SimpleMainGroup, this.product.SimpleSubGroup]
				.filter(p=>p && p.trim() != "")
				.join(" / ");
		}
	},
	async mounted(){
		if (this.useSimpleGroups) return;
		let groups:ProductGroup[] = [];
		if (this.product.GroupID){
			groups.push(await ProductGroupService.getGroupByID(this.product.GroupID));
		}
		for (let group of this.product.Groups){
			groups.push(await ProductGroupService.getGroupByID(group.ProductGroupID));
		}
		groups = groups.filter((g,i)=>groups.findIndex(g2=>g2.ID == g.ID) == i);
		this.groups = groups;
	},
	i18nEx: {
		componentPrefix: "components.products"
	},
});
